import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import moment from 'moment';
import useStyles from 'isomorphic-style-loader/useStyles';
import get from 'lodash/get';
import { getDaysInMonth } from 'helpers/datetime';
import FormGroup from 'components/Form/FormGroup';
import CompoundInput from 'components/Form/CompoundInput';
import App from 'modules/App';
import useFields from './useFields';
import styles from './DateOfBirthFormPartial.pcss';
const DateOfBirthFormPartial = ({ formValues, errorsMessages, isDisabled = false, isOneLiner = false, onSetFormValue })=>{
    useStyles(styles);
    const birthMonth = get(formValues, 'values.dateOfBirth.month');
    const birthYear = get(formValues, 'values.dateOfBirth.year');
    const momentDate = moment().month(0);
    if (birthYear) {
        momentDate.year(Number(birthYear));
    }
    if (birthMonth) {
        momentDate.month(Number(birthMonth) - 1);
    }
    const setDateOfBirth = useCallback((input)=>{
        const { value } = input;
        const daysInMonth = getDaysInMonth(value.month, value.year);
        if (value.day && daysInMonth < Number(value.day)) {
            input.value.day = '';
        }
        onSetFormValue(input);
    }, [
        onSetFormValue
    ]);
    const dateFields = useFields({
        birthMonth,
        birthYear,
        momentDate,
        isDisabled
    });
    return /*#__PURE__*/ _jsx(FormGroup, {
        id: "dateOfBirth",
        labelMessage: App.messages.labels.dateOfBirth,
        formValues: formValues,
        errorsMessages: errorsMessages,
        isOneLiner: isOneLiner,
        children: /*#__PURE__*/ _jsx(CompoundInput, {
            className: styles.dateOfBirth,
            onChange: setDateOfBirth,
            children: dateFields
        })
    });
};
export default DateOfBirthFormPartial;
